import { createApp } from "vue";
import App from "@/App.vue";
import { router } from "@/router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/icons";
import "@/styles/main.css";

const app = createApp(App);
app.component("FontAwesomeIcon", FontAwesomeIcon);
app.use(router);
app.mount("#app");
